import React, { useState, useEffect } from 'react';
import './ImageCarouselVertical.css';

function ImageCarouselVertical({ images }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(goToNext, 7000);
    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  return (
    <div className='carousel-container-vertical'>
      <button onClick={goToPrevious} className='carousel-button-vertical prev'>&#10094;</button>

      <div className='carousel-track-container-vertical'>
        <div
          className='carousel-track-vertical'
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Slide ${index + 1}`}
              className='carousel-image-vertical'
            />
          ))}
        </div>
      </div>

      <button onClick={goToNext} className='carousel-button-vertical next'>&#10095;</button>

      {/* Dots */}
      <div className='carousel-dots-vertical'>
        {images.map((_, index) => (
          <span
            key={index}
            className={`carousel-dot-vertical${index === currentIndex ? ' active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default ImageCarouselVertical;
